import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
// import { useTranslation } from 'react-i18next';

const Navbar = () => {
  const { user, logout } = useAuth();
  const [showLinks, setShowLinks] = useState(false);
  const [typedCommand, setTypedCommand] = useState('');
  const [showOutput, setShowOutput] = useState(false);
  const command = 'ls';

  useEffect(() => {
    if (!showLinks && typedCommand.length < command.length) {
      const timeout = setTimeout(() => {
        setTypedCommand(command.slice(0, typedCommand.length + 1));
      }, 80);
      return () => clearTimeout(timeout);
    } else if (!showLinks && typedCommand.length === command.length && !showOutput) {
      const timeout = setTimeout(() => setShowOutput(true), 350);
      return () => clearTimeout(timeout);
    } else if (!showLinks && showOutput) {
      const timeout = setTimeout(() => setShowLinks(true), 700);
      return () => clearTimeout(timeout);
    }
  }, [typedCommand, showOutput, showLinks]);

  if (!showLinks) {
    return (
      <header className="w-full bg-[#181a1b] border-b border-[#23272e] shadow-md sticky top-0 z-50" dir="ltr">
        <nav className="max-w-4xl mx-auto flex items-center px-6 py-2 font-mono text-[#e5e5e5] text-left">
          <span className="text-[#39c5bb] font-bold select-none mr-2">abdelhadi@blog:~$</span>
          {!showOutput ? (
            <>
              <span className="text-[#00ff66]">{typedCommand}</span>
              <span className="terminal-cursor ml-1" style={{ animation: 'blink 1s steps(1) infinite' }}>|</span>
            </>
          ) : (
            <span className="flex gap-4 text-[#e5e5e5] text-base">
              <Link to="/" className="hover:text-[#00ff66] underline underline-offset-2">about</Link>
              <Link to="/blog" className="hover:text-[#00ff66] underline underline-offset-2">blog</Link>
            </span>
          )}
          <style>{`
            .terminal-cursor { display: inline-block; width: 1ch; }
            @keyframes blink { 0%, 50% { opacity: 1; } 51%, 100% { opacity: 0; } }
          `}</style>
        </nav>
      </header>
    );
  }

  return (
    <header className="w-full bg-[#181a1b] border-b border-[#23272e] shadow-md sticky top-0 z-50" dir="ltr">
      <nav className="max-w-4xl mx-auto flex items-center px-6 py-2 font-mono text-[#e5e5e5] text-left">
        <span className="text-[#39c5bb] font-bold select-none mr-4">abdelhadi@blog:~$</span>
        <Link to="/" className="px-2 py-1 rounded transition-all duration-150 hover:bg-[#23272e] hover:text-[#00ff66] focus:bg-[#23272e] focus:text-[#00ff66] border-b-2 border-transparent hover:border-[#00ff66]">About</Link>
        <Link to="/blog" className="px-2 py-1 rounded transition-all duration-150 hover:bg-[#23272e] hover:text-[#00ff66] focus:bg-[#23272e] focus:text-[#00ff66] border-b-2 border-transparent hover:border-[#00ff66]">Blog</Link>
        {user && (
          <Link to="/dashboard" className="px-2 py-1 rounded transition-all duration-150 hover:bg-[#23272e] hover:text-[#00ff66] focus:bg-[#23272e] focus:text-[#00ff66] border-b-2 border-transparent hover:border-[#00ff66]">Dashboard</Link>
        )}
        <span className="ml-auto flex items-center gap-2">
          {user ? (
            <button onClick={logout} className="px-2 py-1 rounded transition-all duration-150 hover:bg-[#23272e] hover:text-red-400 border-b-2 border-transparent hover:border-red-400">Logout</button>
          ) : null}
        </span>
        <span className="terminal-cursor ml-1" style={{ animation: 'blink 1s steps(1) infinite' }}>|</span>
      </nav>
      <style>{`
        .terminal-cursor { display: inline-block; width: 1ch; }
        @keyframes blink { 0%, 50% { opacity: 1; } 51%, 100% { opacity: 0; } }
      `}</style>
    </header>
  );
};

export default Navbar; 